(function(){
  function buildV2(megaMenuEl){
    if(!megaMenuEl || megaMenuEl.dataset.mmv2Built === "1") return;

    // Horizon yapısındaki kolonları yakala
    const cols = Array.from(megaMenuEl.querySelectorAll(".mega-menu__column"));
    if(!cols.length) return;

    // Orijinal içerik bloğunu bir wrapper içine alıp gizleyeceğiz
    const originalWrap = document.createElement("div");
    originalWrap.className = "mmv2-hide-original";
    cols[0].parentNode.insertBefore(originalWrap, cols[0]);
    cols.forEach(c => originalWrap.appendChild(c));

    // Sağdaki görseli varsa yakala (Horizon bazen mega menüye görsel koyuyor)
    // Senin 2. görseldeki iPhone görseli gibi.
    let rightImgSrc = null;
    const existingImg = megaMenuEl.querySelector("img");
    if(existingImg && existingImg.src) rightImgSrc = existingImg.src;

    // Sol (markalar) için: parent linkleri olan kolonları tara
    const parents = [];
    originalWrap.querySelectorAll(".mega-menu__link--parent").forEach(parentLink=>{
      const col = parentLink.closest(".mega-menu__column");
      if(!col) return;

      // Bu parent’ın alt linklerini al
      const childLinks = Array.from(col.querySelectorAll("a.mega-menu__link:not(.mega-menu__link--parent)"));
      parents.push({
        title: parentLink.textContent.trim(),
        href: parentLink.getAttribute("href") || "#",
        children: childLinks.map(a => ({
          title: a.textContent.trim(),
          href: a.getAttribute("href") || "#"
        }))
      });
    });

    if(!parents.length) return;

    // V2 iskeleti
    const v2 = document.createElement("div");
    v2.className = "mmv2-wrap";
    v2.innerHTML = `
      <div class="mmv2-left"></div>
      <div class="mmv2-mid"><div class="mmv2-grid"></div></div>
      <div class="mmv2-right">${rightImgSrc ? `<img src="${rightImgSrc}" alt="">` : ""}</div>
    `;

    const left = v2.querySelector(".mmv2-left");
    const grid = v2.querySelector(".mmv2-grid");

    function renderChildren(idx){
      grid.innerHTML = "";
      parents[idx].children.forEach(ch=>{
        const a = document.createElement("a");
        a.href = ch.href;
        a.textContent = ch.title;
        grid.appendChild(a);
      });

      // active state
      left.querySelectorAll("a").forEach((a,i)=> a.classList.toggle("is-active", i===idx));
    }

    // Sol listeyi bas
    parents.forEach((p, idx)=>{
      const a = document.createElement("a");
      a.href = p.href;
      a.textContent = p.title;

      // Hover ile içerik değişsin (2. görsel gibi)
      a.addEventListener("mouseenter", ()=> renderChildren(idx));
      // Mobilde tıklayınca da çalışsın
      a.addEventListener("click", (e)=>{
        // Marka linkine gitmek yerine, önce modelleri göstermek istersen:
        // e.preventDefault();
        renderChildren(idx);
      });

      left.appendChild(a);
    });

    // İlk markayı default aç
    renderChildren(0);

    // Mega menu içine ekle
    megaMenuEl.insertBefore(v2, megaMenuEl.firstChild);
    megaMenuEl.dataset.mmv2Built = "1";
  }

  function init(){
    // Sayfada açılan tüm mega menu’leri yakala
    document.querySelectorAll(".mega-menu").forEach(buildV2);
  }

  // İlk yükleme
  document.addEventListener("DOMContentLoaded", init);

  // Header dinamik render olabiliyor: küçük bir observer ile güvene alalım
  const obs = new MutationObserver(()=> init());
  obs.observe(document.documentElement, {childList:true, subtree:true});
})();